<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { IOrderListMessage } from './types';

const props = defineProps<{
  message: IOrderListMessage;
}>();

const { t } = useI18n();

const { title } = props?.message ?? {};
</script>

<template>
  <div class="order-list-card">
    {{ title }}
  </div>
</template>

<style scoped lang="scss">
.order-list-card {
  white-space: normal;
  font-size: 12px;
}
</style>
